import Public from "./pages/Public/Public";
import ChangePassword from "./pages/Public/ChangePassword";
import PublicLogin from "./pages/Public/logins/PublicLogin";
import OfficialLogin from "./pages/Public/logins/OfficialLogin";
import InternalLogin from "./pages/Public/logins/InternalLogin";
import LegitimateLogin from "./pages/Public/logins/LegitimateLogin";
import OvmLogin from "./pages/Public/logins/OvmLogin";
import PublicOfficials from "./pages/Public/Officials/Officials";
import PublicOfficialDetail from "./pages/Public/Officials/OfficialDetail";
import NewInitiativePublic from "./pages/Public/NewInitiative";
import InvestigationFaqPage from "./pages/Public/InvestigationFaqPage";
import NewRequestPublic from "./pages/Public/NewRequest";
import PublicSuccess from "./pages/Public/PublicSuccess";
import InternalUsers from "./pages/InternalUsers/InternalUsers";
import Administrators from "./pages/InternalUsers/Administrators";
import EditInternalUser from "./pages/InternalUsers/EditInternalUser";
import EditAdministrator from "./pages/InternalUsers/EditAdministrator";
import Ovms from "./pages/Ovms/Ovms";
import EditOvm from "./pages/Ovms/EditOvm";
import NewOvm from "./pages/Ovms/NewOvm";
import Financialinstitutions from "./pages/Financialinstitutions/Financialinstitutions";
import EditFinancialinstitutions from "./pages/Financialinstitutions/EditFinancialinstitutions";
import NewFinancialinstitutions from "./pages/Financialinstitutions/NewFinancialinstitutions";
import Legitimates from "./pages/Legitimates/Legitimates";
import EditLegitimate from "./pages/Legitimates/EditLegitimate";
import NewLegitimate from "./pages/Legitimates/NewLegitimate";
import ChangeProfile from "./pages/Officials/ChangeProfile";
import BulkImports from "./pages/Officials/BulkImports";
import BulkImportDetail from "./pages/Officials/BulkImportDetail";
import OvmMissingOfficials from "./pages/Officials/OvmMissingOfficials";
import OfficialsAll from "./pages/Officials/OfficialsAll";
import OfficialHistoryPage from "./pages/Officials/OfficialHistoryPage";
import OvmHistoryPage from "./pages/Ovms/OvmHistoryPage";
import LegitimateHistoryPage from "./pages/Legitimates/LegitimateHistoryPage";
import UserHistoryPage from "./pages/InternalUsers/UserHistoryPage";
import OfficialsNoCreds from "./pages/Officials/OfficialsNoCreds";
import InfoBanner from "./pages/InfoBanner/InfoBanner";
import EditInfoBanner from "./pages/InfoBanner/EditInfoBanner";
import {
  OfficialLateSt,
  OfficialMissingSt,
  OfficialIncompleteSt,
} from "./pages/Officials/OfficialsSt";
import AppealOfficial from "./pages/Officials/AppealOfficial";
import AppealOfficialsBulk from "./pages/Officials/AppealOfficialsBulk";
import EditOfficial from "./pages/Officials/EditOfficial";
import NewOfficial from "./pages/Officials/NewOfficial";
import WhoLooked from "./pages/Officials/WhoLooked";
import Requests from "./pages/Requests/Requests";
import RequestsPublic from "./pages/Requests/RequestsPublic";
import RejectRequest from "./pages/Requests/RejectRequest";
import EditRequest from "./pages/Requests/EditRequest";
import NewRequest from "./pages/Requests/NewRequest";
import Initiatives from "./pages/Initiatives/Initiatives";
import SendInitiative from "./pages/Initiatives/SendInitiative";
import RejectInitiative from "./pages/Initiatives/RejectInitiative";
import EditInitiative from "./pages/Initiatives/EditInitiative";
import NewInitiative from "./pages/Initiatives/NewInitiative";
import InitiativeHistoryPage from "./pages/Initiatives/InitiativeHistoryPage";
import RequestHistoryPage from "./pages/Requests/RequestHistoryPage";
import FinancialInstitutionHistoryPage from "./pages/Financialinstitutions/FinancialInstitutionHistoryPage";
import OverviewHistoryPage from "./pages/History/OverviewHistoryPage";
import Statements from "./pages/Statements/Statements";
import EditStatement from "./pages/Statements/EditStatement";
import NewStatement from "./pages/Statements/NewStatement";
import Statistics from "./pages/Statistics/Statistics";
import ControlBatches from "./pages/Control/ControlBatches";
import ControlBatchDetail from "./pages/Control/ControlBatchDetail";
import Help from "./pages/Help/Help";
import Templates from "./pages/Templates/Templates";
import {
  dictionariesList,
  adminDictionariesList,
} from "./pages/Dictionary/Dictionary";
import DictionaryHistoryPage from "./pages/Dictionary/DictionaryHistoryPage";
import { auth, noauth } from "../../utils/login";
import { canChangePswdOvm } from "../Cro/CroActions";
import AdministratorLogin from "./pages/Public/logins/AdministratorLogin";
import JudgeLogin from "./pages/Public/logins/JudgeLogin";
import Archive from "./pages/Archive/Archive";
import OpenData from "./pages/Public/OpenData";
import NewEmailTemplate from "./pages/Templates/NewEmailTemplate";
import EditEmailTemplate from "./pages/Templates/EditEmailTemplate";
import SamlSignIn from "./pages/Public/logins/SamlLogin";
import NotFound from "../../components/NotFound";
import Settings from "./pages/Settings";
import StatementVersion from "./pages/Statements/StatementVersion";
import EditInspection from "./pages/Inspections/EditInspection";
import NewDocumentTemplate from "./pages/Templates/NewDocumentTemplate";
import EditDocumentTemplate from "./pages/Templates/EditDocumentTemplate";

const law = "https://e-sbirka.gov.cz/sb/2006/159?zalozka=text";
const decree = "https://e-sbirka.gov.cz/sb/2017/79/2019-06-01?zalozka=text";
// WCAG: upozornění pro čtečky obrazovky, že odkaz opouští web (viz TopNav/AppHeader)
const eSbirkaHint = "Otevře se na webu e-Sbírka v nové záložce.";
const news = "https://justice.cz/web/msp/aktuality";
const faq = "https://justice.cz/web/msp/casto-kladene-otazky";

const authOfficialAdmin = (Component) =>
  auth(
    {
      name: "officialAdmin",
      startUrl: "/administrator",
      role: "ROLE_INTERNAL",
      more: ["ROLE_INTERNAL_OFFICIAL_ADMIN"],
    },
    Component,
  );

//const authAdminOnly = Component => auth({ name: 'admin', startUrl: '/spravce', role: 'ROLE_INTERNAL', more: ['ROLE_INTERNAL_ADMIN'] }, Component);
const authAdminInternal = (Component) =>
  auth(
    {
      name: "admin",
      startUrl: "/spravce",
      role: "ROLE_INTERNAL",
      more: ["ROLE_INTERNAL_ADMIN", "ROLE_INTERNAL_USER"],
    },
    Component,
  );

const withDictionary = (dictionary) => (Component) => {
  const Bound = (props) => <Component {...props} dictionary={dictionary} />;
  Bound.displayName = `WithDictionary(${dictionary.name})`;
  return Bound;
};

const authJudge = (Component) =>
  auth(
    {
      name: "judge",
      startUrl: "/soudce",
      role: "ROLE_INTERNAL",
      more: ["ROLE_INTERNAL_JUDGE"],
    },
    Component,
  );

const authOvm = (Component) =>
  auth(
    { name: "ovm", startUrl: "/podpurny-organ", role: "ROLE_OVM" },
    Component,
  );
const authLegit = (Component) =>
  auth(
    {
      name: "legitimate",
      startUrl: "/opravneny-organ",
      role: "ROLE_LEGITIMATE",
    },
    Component,
  );
const authOfficial = (Component) =>
  auth(
    { name: "official", startUrl: "/funkcionar", role: "ROLE_OFFICIAL" },
    Component,
  );
const authPublic = (Component) =>
  auth(
    { name: "publicLogged", startUrl: "/verejnost", role: "ROLE_PUBLIC" },
    Component,
  );

const menuInternal = [
  {
    id: "admin01",
    primaryText: ["Podpůrné", " orgány"],
    path: "/spravce/podpurne-organy",
  },
  {
    id: "admin02",
    primaryText: ["Oprávněné", " orgány"],
    path: "/spravce/opravnene-organy",
  },
  {
    id: "admin12",
    primaryText: ["Finanční", " instituce"],
    path: "/spravce/financni-instituce",
  },
  {
    id: "admin03",
    primaryText: "Funkcionáři",
    path: "/spravce/funkcionari",
  },
  //{ id: 'admin08', primaryText: 'Bez údajů', path: '/spravce/funkcionari/bez-udaju', parent: 'admin03' },
  {
    id: "admin09",
    primaryText: ["Žádosti o nahlédnutí", "na neveřejné oznámení"],
    path: "/spravce/zadosti",
  },
  {
    id: "admin10",
    primaryText: ["Podněty", "k prošetření"],
    path: "/spravce/podnety",
  },
  { id: "admin11", primaryText: "Archivace", path: "/spravce/archivace" },
  { id: "cis", primaryText: "Číselníky", path: "/spravce/ciselniky" },
  ...dictionariesList.map((d, i) => ({
    id: `cis${i}`,
    primaryText: d.h1,
    path: `/spravce/ciselniky/${d.name}`,
    parent: "cis",
  })),
  { id: "adminSS", primaryText: "Statistiky", path: "/spravce/statistiky" },
  { id: "adminNN", primaryText: "Nápovědy", path: "/spravce/napovedy" },
];

const menuPublicFree = [
  {
    id: "publicFree01",
    primaryText: "Žádost o nahlížení na neveřejné oznámení",
    path: "/verejnost/zadost",
  },
  {
    id: "publicFree02",
    primaryText: "Podnět k prošetření",
    path: "/verejnost/podnet",
  },
  {
    id: "publicFree03",
    primaryText: "Zákon o střetu zájmů",
    link: law,
    target: "_blank",
    srHint: eSbirkaHint,
  },
  {
    id: "publicFree03b",
    primaryText: "Vyhláška – struktura a formát oznámení",
    link: decree,
    target: "_blank",
    srHint: eSbirkaHint,
  },
  { id: "publicFree04", primaryText: "Aktuality", link: news },
  {
    id: "publicFree06",
    primaryText: "Otevřená data",
    path: "/verejnost/otevrena-data",
  },
  { id: "publicFree05", primaryText: "Často kladené otázky", link: faq },
  // { id: "publicLogin", primaryText: "Přihlásit se jako", path: "/prihlaseni" },
  {
    id: "publicLogin01",
    primaryText: ["Žadatel", " o nahlížení"],
    path: "/prihlaseni/verejnost",
    parent: "publicLogin",
  },
  {
    id: "publicLogin02",
    primaryText: "Veřejný funkcionář",
    path: "/prihlaseni/funkcionar",
    parent: "publicLogin",
  },
  {
    id: "publicLogin03",
    primaryText: "Podpůrný (zapisující) orgán",
    path: "/prihlaseni/podpurny-organ",
    parent: "publicLogin",
  },
  {
    id: "publicLogin04",
    primaryText: "Oprávněný orgán",
    path: "/prihlaseni/opravneny-organ",
    parent: "publicLogin",
  },
];

export default {
  admin: {
    routes: [
      {
        path: "/spravce/administratori",
        component: authAdminInternal(Administrators),
        pageTitle: "Přehled administrátorů",
      },
      {
        path: "/spravce/administratori/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie administrátorů",
      },
      {
        path: "/spravce/administratori/:id/historie",
        component: authAdminInternal(UserHistoryPage),
        pageTitle: "Historie aktivit administrátora",
      },
      {
        path: "/spravce/administratori/:id",
        component: authAdminInternal(EditAdministrator),
        pageTitle: "Detail administrátora",
      },
      {
        path: "/spravce/spravci",
        component: authAdminInternal(InternalUsers),
        pageTitle: "Přehled správců",
      },
      {
        path: "/spravce/spravci/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie správců",
      },
      {
        path: "/spravce/spravci/:id/historie",
        component: authAdminInternal(UserHistoryPage),
        pageTitle: "Historie aktivit správce",
      },
      {
        path: "/spravce/spravci/:id",
        component: authAdminInternal(EditInternalUser),
        pageTitle: "Detail správce",
      },
      {
        path: "/spravce/podpurne-organy",
        component: authAdminInternal(Ovms),
        pageTitle: "Přehled podpůrných orgánů",
      },
      {
        path: "/spravce/podpurne-organy/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie podpůrných orgánů",
      },
      {
        path: "/spravce/podpurne-organy/:id/historie",
        component: authAdminInternal(OvmHistoryPage),
        pageTitle: "Historie podpůrného orgánu",
      },
      {
        path: "/spravce/podpurne-organy/form/:id",
        component: authAdminInternal(EditOvm),
        pageTitle: "Editace podpůrného orgánu",
      },
      {
        path: "/spravce/podpurne-organy/form",
        component: authAdminInternal(NewOvm),
        pageTitle: "Nový podpůrný orgán",
      },

      {
        path: "/spravce/opravnene-organy",
        component: authAdminInternal(Legitimates),
        pageTitle: "Přehled oprávněných orgánů",
      },
      {
        path: "/spravce/opravnene-organy/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie oprávněných orgánů",
      },
      {
        path: "/spravce/opravnene-organy/:id/historie",
        component: authAdminInternal(LegitimateHistoryPage),
        pageTitle: "Historie oprávněného orgánu",
      },
      {
        path: "/spravce/opravnene-organy/form/:id",
        component: authAdminInternal(EditLegitimate),
        pageTitle: "Editace oprávněného orgánu",
      },
      {
        path: "/spravce/opravnene-organy/form",
        component: authAdminInternal(NewLegitimate),
        pageTitle: "Nový oprávněný orgán",
      },

      {
        path: "/spravce/funkcionari",
        component: authAdminInternal(OfficialsAll),
        pageTitle: "Přehled funkcionářů",
      },
      {
        path: "/spravce/funkcionari/bez-udaju",
        component: authAdminInternal(OfficialsNoCreds),
        pageTitle: "Funkcionáři bez údajů",
      },
      { path: "/spravce/funkcionari/:id/oznameni/verze", 
        component: authAdminInternal(StatementVersion), 
        pageTitle: "Odeslaná verze oznámení"
      },
      {
        path: "/spravce/funkcionari/:id/oznameni/:statement_id",
        component: authAdminInternal(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/spravce/funkcionari/:id/vyzva",
        component: authAdminInternal(AppealOfficial),
        pageTitle: "Výzva veřejnému funkcionáři",
      },
      {
        path: "/spravce/funkcionari/hromadna-vyzva",
        component: authAdminInternal(AppealOfficialsBulk),
        pageTitle: "Výzva veřejným funkcionářům",
      },
      {
        path: "/spravce/funkcionari/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie funkcionářů",
      },
      {
        path: "/spravce/funkcionari/:id/historie",
        component: authAdminInternal(OfficialHistoryPage),
        pageTitle: "Historie funkcionáře",
      },
      {
        path: "/spravce/funkcionari/form/:id",
        component: authAdminInternal(EditOfficial),
        pageTitle: "Detail funkcionáře",
      },
      {
        path: "/spravce/funkcionari/form",
        component: authAdminInternal(NewOfficial),
        pageTitle: "Nový funkcionář",
      },
      {
        path: "/spravce/funkcionari/:id/kontroly/:inspection_id",
        component: authAdminInternal(EditInspection),
        pageTitle: "Úprava kontroly",
      },

      {
        path: "/spravce/zadosti",
        component: authAdminInternal(Requests),
        pageTitle: "Žádosti o nahlédnutí na neveřejné oznámení",
      },
      {
        path: "/spravce/zadosti/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie žádostí",
      },
      {
        path: "/spravce/zadosti/:id/zamitnout",
        component: authAdminInternal(RejectRequest),
        pageTitle: "Zamítnutí žádosti",
      },
      {
        path: "/spravce/zadosti/:id/historie",
        component: authAdminInternal(RequestHistoryPage),
        pageTitle: "Historie žádosti",
      },
      {
        path: "/spravce/zadosti/form/:id",
        component: authAdminInternal(EditRequest),
        pageTitle: "Editace žádosti",
      },
      {
        path: "/spravce/zadosti/form",
        component: authAdminInternal(NewRequest),
        pageTitle: "Nová žádost",
      },

      {
        path: "/spravce/podnety",
        component: authAdminInternal(Initiatives),
        pageTitle: "Podněty k prošetření",
      },
      {
        path: "/spravce/podnety/:id/postoupit",
        component: authAdminInternal(SendInitiative),
        pageTitle: "Postoupení podnětu",
      },
      {
        path: "/spravce/podnety/:id/zamitnout",
        component: authAdminInternal(RejectInitiative),
        pageTitle: "Zamítnutí podnětu",
      },
      {
        path: "/spravce/podnety/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie podnětů",
      },
      {
        path: "/spravce/podnety/:id/historie",
        component: authAdminInternal(InitiativeHistoryPage),
        pageTitle: "Historie podnětu",
      },
      {
        path: "/spravce/podnety/form/:id",
        component: authAdminInternal(EditInitiative),
        pageTitle: "Editace podnětu",
      },
      {
        path: "/spravce/podnety/form",
        component: authAdminInternal(NewInitiative),
        pageTitle: "Nový podnět",
      },

      {
        path: "/spravce/archivace/:tab",
        component: authAdminInternal(Archive),
        pageTitle: "Archivace",
      },
      {
        path: "/spravce/archivace",
        component: authAdminInternal(Archive),
        pageTitle: "Archivace",
      },

      {
        path: "/spravce/financni-instituce",
        component: authAdminInternal(Financialinstitutions),
        pageTitle: "Přehled finančních institucí",
      },
      {
        path: "/spravce/financni-instituce/form/:id",
        component: authAdminInternal(EditFinancialinstitutions),
        pageTitle: "Editace finanční instituce",
      },
      {
        path: "/spravce/financni-instituce/:id/historie",
        component: authAdminInternal(FinancialInstitutionHistoryPage),
        pageTitle: "Historie finanční instituce",
      },
      {
        path: "/spravce/financni-instituce/form",
        component: authAdminInternal(NewFinancialinstitutions),
        pageTitle: "Nová finanční instituce",
      },

      ...dictionariesList.map((d) => ({
        path: `/spravce/ciselniky/${d.name}/historie`,
        component: authAdminInternal(withDictionary(d)(DictionaryHistoryPage)),
        pageTitle: `${d.h1} - historie`,
      })),
      ...dictionariesList.map((d) => ({
        path: `/spravce/ciselniky/${d.name}`,
        component: authAdminInternal(d.grid),
        pageTitle: d.h1,
      })),
      ...dictionariesList.map((d) => ({
        path: `/spravce/ciselniky/${d.name}/form`,
        component: authAdminInternal(d.newForm),
        pageTitle: `${d.h1} - nový záznam`,
      })),
      ...dictionariesList.map((d) => ({
        path: `/spravce/ciselniky/${d.name}/form/:id`,
        component: authAdminInternal(d.editForm),
        pageTitle: `${d.h1} - detail`,
      })),

      {
        path: "/spravce/statistiky/:stat",
        component: authAdminInternal(Statistics),
        pageTitle: "Statistiky",
      },
      {
        path: "/spravce/statistiky",
        component: authAdminInternal(Statistics),
        pageTitle: "Statistiky",
      },
      {
        path: "/spravce/napovedy/historie",
        component: authAdminInternal(OverviewHistoryPage),
        pageTitle: "Historie nápověd",
      },
      {
        path: "/spravce/napovedy",
        component: authAdminInternal(Help),
        pageTitle: "Nápovědy",
      },
    ],
    menu: [
      {
        id: "admin000",
        primaryText: "Administrátoři",
        path: "/spravce/administratori",
      },
      { id: "admin00", primaryText: "Správci", path: "/spravce/spravci" },
      ...menuInternal,
    ],
  },
  internal: {
    routes: [], //same as admin
    menu: menuInternal,
  },

  officialAdmin: {
    routes: [
      {
        path: "/administrator/administratori",
        component: authOfficialAdmin(Administrators),
        pageTitle: "Přehled administrátorů",
      },
      {
        path: "/administrator/administratori/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie administrátorů",
      },
      {
        path: "/administrator/administratori/:id/historie",
        component: authOfficialAdmin(UserHistoryPage),
        pageTitle: "Historie aktivit administrátora",
      },
      {
        path: "/administrator/administratori/:id",
        component: authOfficialAdmin(EditAdministrator),
        pageTitle: "Detail administrátora",
      },

      {
        path: "/administrator/spravci",
        component: authOfficialAdmin(InternalUsers),
        pageTitle: "Přehled správců",
      },
      {
        path: "/administrator/spravci/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie správců",
      },
      {
        path: "/administrator/spravci/:id/historie",
        component: authOfficialAdmin(UserHistoryPage),
        pageTitle: "Historie aktivit správce",
      },
      {
        path: "/administrator/spravci/:id",
        component: authOfficialAdmin(EditInternalUser),
        pageTitle: "Detail správce",
      },

      {
        path: "/administrator/funkcionari",
        component: authOfficialAdmin(OfficialsAll),
        pageTitle: "Přehled funkcionářů",
      },
      {
        path: "/administrator/funkcionari/bez-udaju",
        component: authOfficialAdmin(OfficialsNoCreds),
        pageTitle: "Funkcionáři bez údajů",
      },

      {
        path: "/administrator/funkcionari/:id/oznameni/form",
        component: authOfficialAdmin(NewStatement),
        pageTitle: "Nové oznámení funkcionáře",
      },
      {
        path: "/administrator/funkcionari/:id/oznameni/verze",
        component: authOfficialAdmin(StatementVersion),
        pageTitle: "Odeslaná verze oznámení",
      },
      {
        path: "/administrator/funkcionari/:id/oznameni/:statement_id",
        component: authOfficialAdmin(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/administrator/funkcionari/:id/vyzva",
        component: authOfficialAdmin(AppealOfficial),
        pageTitle: "Výzva veřejnému funkcionáři",
      },
      {
        path: "/administrator/funkcionari/hromadna-vyzva",
        component: authOfficialAdmin(AppealOfficialsBulk),
        pageTitle: "Výzva veřejným funkcionářům",
      },
      {
        path: "/administrator/funkcionari/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie funkcionářů",
      },
      {
        path: "/administrator/funkcionari/:id/historie",
        component: authOfficialAdmin(OfficialHistoryPage),
        pageTitle: "Historie funkcionáře",
      },
      {
        path: "/administrator/funkcionari/form/:id",
        component: authOfficialAdmin(EditOfficial),
        pageTitle: "Editace funkcionáře",
      },
      {
        path: "/administrator/funkcionari/form",
        component: authOfficialAdmin(NewOfficial),
        pageTitle: "Nový funkcionář",
      },
      {
        path: "/administrator/funkcionari/:id/kontroly/:inspection_id",
        component: authOfficialAdmin(EditInspection),
        pageTitle: "Úprava kontroly",
      },

      {
        path: "/administrator/napovedy/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie nápověd",
      },
      {
        path: "/administrator/napovedy",
        component: authOfficialAdmin(Help),
        pageTitle: "Nápovědy",
      },

      {
        path: "/administrator/archivace/:tab",
        component: authOfficialAdmin(Archive),
        pageTitle: "Archivace",
      },
      {
        path: "/administrator/archivace",
        component: authOfficialAdmin(Archive),
        pageTitle: "Archivace",
      },

      {
        path: "/administrator/financni-instituce",
        component: authOfficialAdmin(Financialinstitutions),
        pageTitle: "Přehled finančních institucí",
      },
      {
        path: "/administrator/financni-instituce/form/:id",
        component: authOfficialAdmin(EditFinancialinstitutions),
        pageTitle: "Editace finanční instituce",
      },
      {
        path: "/administrator/financni-instituce/:id/historie",
        component: authOfficialAdmin(FinancialInstitutionHistoryPage),
        pageTitle: "Historie finanční instituce",
      },
      {
        path: "/administrator/financni-instituce/form",
        component: authOfficialAdmin(NewFinancialinstitutions),
        pageTitle: "Nová finanční instituce",
      },

      {
        path: "/administrator/opravnene-organy",
        component: authOfficialAdmin(Legitimates),
        pageTitle: "Přehled oprávněných orgánů",
      },
      {
        path: "/administrator/opravnene-organy/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie oprávněných orgánů",
      },
      {
        path: "/administrator/opravnene-organy/:id/historie",
        component: authOfficialAdmin(LegitimateHistoryPage),
        pageTitle: "Historie oprávněného orgánu",
      },
      {
        path: "/administrator/opravnene-organy/form/:id",
        component: authOfficialAdmin(EditLegitimate),
        pageTitle: "Editace oprávněného orgánu",
      },
      {
        path: "/administrator/opravnene-organy/form",
        component: authOfficialAdmin(NewLegitimate),
        pageTitle: "Nový oprávněný orgán",
      },

      {
        path: "/administrator/podpurne-organy",
        component: authOfficialAdmin(Ovms),
        pageTitle: "Přehled podpůrných orgánů",
      },
      {
        path: "/administrator/podpurne-organy/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie podpůrných orgánů",
      },
      {
        path: "/administrator/podpurne-organy/:id/historie",
        component: authOfficialAdmin(OvmHistoryPage),
        pageTitle: "Historie podpůrného orgánu",
      },
      {
        path: "/administrator/podpurne-organy/form/:id",
        component: authOfficialAdmin(EditOvm),
        pageTitle: "Editace podpůrného orgánu",
      },
      {
        path: "/administrator/podpurne-organy/form",
        component: authOfficialAdmin(NewOvm),
        pageTitle: "Nový podpůrný orgán",
      },

      {
        path: "/administrator/kontrola",
        component: authOfficialAdmin(ControlBatches),
        pageTitle: "Náhodný generátor veřejných funkcionářů pro kontrolu",
      },
      {
        path: "/administrator/kontrola/:id",
        component: authOfficialAdmin(ControlBatchDetail),
        pageTitle: "Detail kontrolní dávky",
      },

      {
        path: "/administrator/zadosti",
        component: authOfficialAdmin(Requests),
        pageTitle: "Žádosti o nahlédnutí na neveřejné oznámení",
      },
      {
        path: "/administrator/zadosti/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie žádostí",
      },
      {
        path: "/administrator/zadosti/:id/zamitnout",
        component: authOfficialAdmin(RejectRequest),
        pageTitle: "Zamítnutí žádosti",
      },
      {
        path: "/administrator/zadosti/:id/historie",
        component: authOfficialAdmin(RequestHistoryPage),
        pageTitle: "Historie žádosti",
      },
      {
        path: "/administrator/zadosti/form/:id",
        component: authOfficialAdmin(EditRequest),
        pageTitle: "Editace žádosti",
      },
      {
        path: "/administrator/zadosti/form",
        component: authOfficialAdmin(NewRequest),
        pageTitle: "Nová žádost",
      },

      {
        path: "/administrator/podnety",
        component: authOfficialAdmin(Initiatives),
        pageTitle: "Podněty k prošetření",
      },
      {
        path: "/administrator/podnety/:id/postoupit",
        component: authOfficialAdmin(SendInitiative),
        pageTitle: "Postoupení podnětu",
      },
      {
        path: "/administrator/podnety/:id/zamitnout",
        component: authOfficialAdmin(RejectInitiative),
        pageTitle: "Zamítnutí podnětu",
      },
      {
        path: "/administrator/podnety/historie",
        component: authOfficialAdmin(OverviewHistoryPage),
        pageTitle: "Historie podnětů",
      },
      {
        path: "/administrator/podnety/:id/historie",
        component: authOfficialAdmin(InitiativeHistoryPage),
        pageTitle: "Historie podnětu",
      },
      {
        path: "/administrator/podnety/form/:id",
        component: authOfficialAdmin(EditInitiative),
        pageTitle: "Editace podnětu",
      },
      {
        path: "/administrator/podnety/form",
        component: authOfficialAdmin(NewInitiative),
        pageTitle: "Nový podnět",
      },

      {
        path: "/administrator/sablony/:tab",
        component: authOfficialAdmin(Templates),
        pageTitle: "Šablony",
      },
      {
        path: "/administrator/sablony",
        component: authOfficialAdmin(Templates),
        pageTitle: "Šablony",
      },
      {
        path: "/administrator/sablony/email/form",
        component: authOfficialAdmin(NewEmailTemplate),
        pageTitle: "Nová emailová šablona",
      },
      {
        path: "/administrator/sablony/email/form/:id",
        component: authOfficialAdmin(EditEmailTemplate),
        pageTitle: "Editace emailové šablony",
      },
      {
        path: "/administrator/sablony/dokument/form",
        component: authOfficialAdmin(NewDocumentTemplate),
        pageTitle: "Nová šablona dokumentu",
      },
      {
        path: "/administrator/sablony/dokument/form/:id",
        component: authOfficialAdmin(EditDocumentTemplate),
        pageTitle: "Editace šablony dokumentu",
      },
      {
        path: "/administrator/upozorneni",
        component: authOfficialAdmin(InfoBanner),
        pageTitle: "Správa upozornění",
      },
      {
        path: "/administrator/upozorneni/form/:id",
        component: authOfficialAdmin(EditInfoBanner),
        pageTitle: "Editace upozornění",
      },
      ...[...dictionariesList, ...adminDictionariesList].map(function (d) {
        return {
          path: "/administrator/ciselniky/" + d.name + "/historie",
          component: authOfficialAdmin(withDictionary(d)(DictionaryHistoryPage)),
          pageTitle: d.h1 + " - historie",
        };
      }),

      ...[...dictionariesList, ...adminDictionariesList].map(function (d) {
        return {
          path: "/administrator/ciselniky/" + d.name,
          component: authOfficialAdmin(d.grid),
          pageTitle: d.h1,
        };
      }),

      ...[...dictionariesList, ...adminDictionariesList].map(function (d) {
        return {
          path: "/administrator/ciselniky/" + d.name + "/form",
          component: authOfficialAdmin(d.newForm),
          pageTitle: d.h1 + " - nový záznam",
        };
      }),

      ...[...dictionariesList, ...adminDictionariesList].map(function (d) {
        return {
          path: "/administrator/ciselniky/" + d.name + "/form/:id",
          component: authOfficialAdmin(d.editForm),
          pageTitle: d.h1 + " - detail",
        };
      }),
      {
        path: "/administrator/nastaveni",
        component: authOfficialAdmin(Settings),
        pageTitle: "Nastavení aplikace",
      },
      {
        path: "/administrator/statistiky/:stat",
        component: authOfficialAdmin(Statistics),
        pageTitle: "Statistiky",
      },
      {
        path: "/administrator/statistiky",
        component: authOfficialAdmin(Statistics),
        pageTitle: "Statistiky",
      },
    ],

    menu: [
      {
        id: "officialAdmin000",
        primaryText: "Administrátoři",
        path: "/administrator/administratori",
      },

      {
        id: "officialAdmin00",
        primaryText: "Správci",
        path: "/administrator/spravci",
      },

      {
        id: "officialAdmin01",
        primaryText: ["Podpůrné", " orgány"],
        path: "/administrator/podpurne-organy",
      },

      {
        id: "officialAdmin02",
        primaryText: ["Oprávněné", " orgány"],
        path: "/administrator/opravnene-organy",
      },

      {
        id: "officialAdmin12",
        primaryText: ["Finanční", " instituce"],
        path: "/administrator/financni-instituce",
      },

      {
        id: "officialAdmin03",
        primaryText: "Funkcionáři",
        path: "/administrator/funkcionari",
      },

      {
        id: "officialAdmin09",
        primaryText: ["Žádosti o nahlédnutí", "na neveřejné oznámení"],
        path: "/administrator/zadosti",
      },

      {
        id: "officialAdmin10",
        primaryText: ["Podněty", "k prošetření"],
        path: "/administrator/podnety",
      },

      {
        id: "officialAdmin11",
        primaryText: "Archivace",
        path: "/administrator/archivace",
      },

      {
        id: "officialAdminCis",
        primaryText: "Číselníky",
        path: "/administrator/ciselniky",
      },

      ...[...dictionariesList, ...adminDictionariesList].map((d, i) => ({
        id: `officialAdminCis${i}`,
        primaryText: d.h1,
        path: `/administrator/ciselniky/${d.name}`,
        parent: "officialAdminCis",
      })),

      {
        id: "officialAdminSS",
        primaryText: "Statistiky",
        path: "/administrator/statistiky",
      },

      {
        id: "officialAdminNN",
        primaryText: "Nápovědy",
        path: "/administrator/napovedy",
      },

      {
        id: "officialAdminKontrola",
        primaryText: "Generátor",
        path: "/administrator/kontrola",
      },

      {
        id: "officialAdminSablony",
        primaryText: "Šablony",
        path: "/administrator/sablony",
      },
      {
        id: "officialAdminBanner",
        primaryText: "Upozornění",
        path: "/administrator/upozorneni",
      },
      {
        id: "officialAdminSettings",
        primaryText: "Nastavení",
        path: "/administrator/nastaveni",
      },
    ],
  },

  judge: {
    routes: [
      {
        path: "/soudce/funkcionari/form/:id",
        component: authJudge(EditOfficial),
        pageTitle: "Detail funkcionáře",
      },
      {
        path: "/soudce/funkcionari",
        component: authJudge(OfficialsAll),
        pageTitle: "Přehled funkcionářů",
      },
      {
        path: "/soudce/funkcionari/:id/oznameni/:statement_id",
        component: authJudge(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
    ],
    menu: [
      {
        id: "judge00",
        primaryText: "Funkcionáři",
        path: "/soudce/funkcionari",
      },
    ],
  },

  ovm: {
    routes: [
      {
        path: "/podpurny-organ/funkcionari",
        component: authOvm(OfficialsAll),
        pageTitle: "Přehled funkcionářů",
      },
      {
        path: "/podpurny-organ/funkcionari/:id/oznameni/:statement_id",
        component: authOvm(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/podpurny-organ/funkcionari/form/:id",
        component: authOvm(EditOfficial),
        pageTitle: "Detail funkcionáře",
      },
      {
        path: "/podpurny-organ/funkcionari/form",
        component: authOvm(NewOfficial),
        pageTitle: "Nový funkcionář",
      },
      {
        path: "/podpurny-organ/funkcionari-chybejici",
        component: authOvm(OvmMissingOfficials),
        pageTitle: "Funkcionáři s chybějícím oznámením",
      },
      {
        path: "/podpurny-organ/hromadne-zapisy/:id",
        component: authOvm(BulkImportDetail),
        pageTitle: "Detail hromadného zápisu",
      },
      /*{
        path: "/podpurny-organ/hromadne-zapisy",
        component: authOvm(BulkImports),
        pageTitle: "Přehled hromadných zápisů",
      },*/
      {
        path: "/podpurny-organ/zmena-hesla",
        component: authOvm(ChangePassword),
        pageTitle: "Změna hesla",
      },
    ],
    menu: [
      {
        id: "ovm01",
        primaryText: "Funkcionáři",
        path: "/podpurny-organ/funkcionari",
      },
      {
        id: "ovm04",
        primaryText: ["Funkcionáři s chybějícím", "oznámením"],
        path: "/podpurny-organ/funkcionari-chybejici",
      },
      /*{
        id: "ovm03",
        primaryText: ["Přehled hromadných", "zápisů"],
        path: "/podpurny-organ/hromadne-zapisy",
      },*/
      {
        id: "ovm02",
        primaryText: "Zákon o střetu zájmů",
        link: law,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "ovm02b",
        primaryText: "Vyhláška – struktura a formát oznámení",
        link: decree,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "ovmCP",
        primaryText: "Změna hesla",
        path: "/podpurny-organ/zmena-hesla",
        conditionFn: async () => await canChangePswdOvm(),
      },
    ],
  },

  legitimate: {
    routes: [
      {
        path: "/opravneny-organ/funkcionari",
        component: authLegit(OfficialsAll),
        pageTitle: "Přehled funkcionářů",
      },
      {
        path: "/opravneny-organ/funkcionari/:id/oznameni/:statement_id",
        component: authLegit(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/opravneny-organ/funkcionari/form/:id",
        component: authLegit(EditOfficial),
        pageTitle: "Detail funkcionáře",
      },
      {
        path: "/opravneny-organ/zmena-hesla",
        component: authLegit(ChangePassword),
        pageTitle: "Změna hesla",
      },
    ],
    menu: [
      {
        id: "legitimate03",
        primaryText: "Veřejní funkcionáři",
        path: "/opravneny-organ/funkcionari",
      },
      {
        id: "legitimate04",
        primaryText: "Zákon o střetu zájmů",
        link: law,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "legitimate05",
        primaryText: "Vyhláška – struktura a formát oznámení",
        link: decree,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "legitimateCP",
        primaryText: "Změna hesla",
        path: "/opravneny-organ/zmena-hesla",
      },
    ],
  },

  official: {
    routes: [
      {
        path: "/funkcionar/oznameni",
        component: authOfficial(Statements),
        pageTitle: "Přehled oznámení",
      },
      {
        path: "/funkcionar/oznameni/form/:id",
        component: authOfficial(EditStatement),
        pageTitle: "Úprava oznámení",
      },
      {
        path: "/funkcionar/oznameni/form/:id/kopie",
        component: authOfficial(EditStatement),
        pageTitle: "Nové oznámení ze šablony",
      },
      {
        path: "/funkcionar/oznameni/form",
        component: authOfficial(NewStatement),
        pageTitle: "Nové oznámení",
      },
      {
        path: "/funkcionar/kdo-nahlizel",
        component: authOfficial(WhoLooked),
        pageTitle: "Kdo na mě nahlížel",
      },
      {
        path: "/funkcionar/zmena-profilu",
        component: authOfficial(ChangeProfile),
        pageTitle: "Změna profilu",
      },
      {
        path: "/funkcionar/zmena-hesla",
        component: authOfficial(ChangePassword),
        pageTitle: "Změna hesla",
      },
    ],
    menu: [
      {
        id: "official01",
        primaryText: "Oznámení",
        path: "/funkcionar/oznameni",
      },
      {
        id: "official02",
        primaryText: "Zákon o střetu zájmů",
        link: law,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "official02b",
        primaryText: "Vyhláška – struktura a formát oznámení",
        link: decree,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "officialKN",
        primaryText: "Kdo na mě nahlížel",
        path: "/funkcionar/kdo-nahlizel",
      },
      {
        id: "officialZP",
        primaryText: "Změna profilu",
        path: "/funkcionar/zmena-profilu",
      },
      {
        id: "officialCP",
        primaryText: "Změna hesla",
        path: "/funkcionar/zmena-hesla",
      },
      {
        id: "officialFAQ",
        primaryText: "Často kladené otázky",
        link: "https://msp.gov.cz/web/msp/casto-kladene-otazky/-/clanek/casto-kladene-otazky",
        target: "_blank",
      },
    ],
  },

  publicFree: {
    routes: [
      { path: "/", component: noauth(Public), pageTitle: "Hlavní stránka" },
      {
        path: "/verejnost",
        component: noauth(PublicSuccess),
        pageTitle: "Odesláno",
      },
      {
        path: "/verejnost/podnet",
        component: noauth(InvestigationFaqPage),
        pageTitle: "Podnět k prošetření",
      },
      {
        path: "/verejnost/podnet/form",
        component: noauth(NewInitiativePublic),
        pageTitle: "Nový podnět",
      },
      {
        path: "/verejnost/zadost",
        component: noauth(NewRequestPublic),
        pageTitle: "Žádost o nahlížení na neveřejné oznámení",
      },
      {
        path: "/verejnost/funkcionari",
        component: noauth(PublicOfficials),
        pageTitle: "Vyhledávání funkcionářů",
      },
      {
        path: "/verejnost/funkcionari/:id/oznameni/:statement_id",
        component: noauth(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/verejnost/funkcionari/form/:id",
        component: noauth(PublicOfficialDetail),
        pageTitle: "Detail funkcionáře",
      },
      {
        path: "/verejnost/otevrena-data",
        component: noauth(OpenData),
        pageTitle: "Otevřená data",
      },
      {
        path: "/prihlaseni/verejnost",
        component: noauth(PublicLogin),
        pageTitle: "Přihlášení - žadatel o nahlížení",
      },
      {
        path: "/prihlaseni/spravce",
        component: noauth(InternalLogin),
        pageTitle: "Přihlášení - správce",
      },
      {
        path: "/prihlaseni/funkcionar",
        component: noauth(OfficialLogin),
        pageTitle: "Přihlášení - veřejný funkcionář",
      },
      {
        path: "/prihlaseni/podpurny-organ",
        component: noauth(OvmLogin),
        pageTitle: "Přihlášení - podpůrný orgán",
      },
      {
        path: "/prihlaseni/opravneny-organ",
        component: noauth(LegitimateLogin),
        pageTitle: "Přihlášení - oprávněný orgán",
      },
      {
        path: "/prihlaseni/soudce",
        component: noauth(JudgeLogin),
        pageTitle: "Přihlášení - soudce",
      },
      {
        path: "/prihlaseni/administrator",
        component: noauth(AdministratorLogin),
        pageTitle: "Přihlášení - administrátor",
      },
      {
        path: "/login/saml2/sso/nia",
        component: noauth(SamlSignIn),
        pageTitle: "Přihlášení",
      },
    ],
    menu: [
      ...menuPublicFree,
      {
        id: "publicLoginJudge",
        primaryText: "Nejvyšší soud",
        path: "/prihlaseni/soudce",
        parent: "publicLogin",
      },
      {
        id: "publicLoginOfficialAdmin",
        primaryText: "Administrátor",
        path: "/prihlaseni/administrator",
        parent: "publicLogin",
      },
      {
        id: "publicLoginAdmin",
        primaryText: "Správce",
        path: "/prihlaseni/spravce",
        parent: "publicLogin",
      },
    ],
  },
  publicFreeNoAdmin: {
    routes: [], //same as publicFree
    menu: menuPublicFree,
  },

  publicLogged: {
    routes: [
      //TODO change password route + menu
      {
        path: "/verejnost-prihlasen/hlavni",
        component: authPublic(Public),
        pageTitle: "Hlavní stránka",
      },
      {
        path: "/verejnost-prihlasen/zadosti",
        component: authPublic(RequestsPublic),
        pageTitle: "Žádosti o neveřejné oznámení",
      },
      {
        path: "/verejnost-prihlasen/zadosti/form/:id",
        component: authPublic(EditRequest),
        pageTitle: "Editace žádosti",
      },
      {
        path: "/verejnost-prihlasen/funkcionari",
        component: authPublic(PublicOfficials),
        pageTitle: "Vyhledávání funkcionářů",
      },
      {
        path: "/verejnost-prihlasen/funkcionari/:id/oznameni/:statement_id",
        component: authPublic(EditStatement),
        pageTitle: "Oznámení funkcionáře",
      },
      {
        path: "/verejnost-prihlasen/funkcionari/form/:id",
        component: authPublic(PublicOfficialDetail),
        pageTitle: "Detail funkcionáře",
      },
      // { path: '/verejnost-prihlasen/zmena-hesla', component: authPublic(ChangePassword) },
      {
        path: "*",
        component: noauth(NotFound),
        pageTitle: "Stránka nenalezena",
      },
    ],
    menu: [
      {
        id: "publicLogged00",
        primaryText: "Hlavní stránka",
        path: "/verejnost-prihlasen/hlavni",
      },
      // { id: 'publicLogged01', primaryText: 'Podněty', path: '/verejnost-prihlasen/podnety' }, //TODO bude?
      {
        id: "publicLogged02",
        primaryText: "Žádosti o neveřejné oznámení",
        path: "/verejnost-prihlasen/zadosti",
      },
      // { id: 'publicLoggedCP', primaryText: 'Změna hesla', path: '/verejnost-prihlasen/zmena-hesla' },
      {
        id: "publicLogged03",
        primaryText: "Zákon o střetu zájmů",
        link: law,
        target: "_blank",
        srHint: eSbirkaHint,
      },
      {
        id: "publicLogged04",
        primaryText: "Vyhláška – struktura a formát oznámení",
        link: decree,
        target: "_blank",
        srHint: eSbirkaHint,
      },
    ],
  },
};
